import React from 'react'
import PersonalData from './Tabs/PersonalData.js'
import Project from './Tabs/Project.js';
import Uploads from './Tabs/Uploads.js';
import { getTranslation } from '../Utilities/GetTranslation.js';
    
const applyBusinessTabs = 
[
    {name: getTranslation("sns.webparts.jobapply.personaldata"), component: <PersonalData/>, id: "personaldata"},
    {name: getTranslation("sns.webparts.jobapply.project"), component: <Project/>, id: "project"},
    {name: getTranslation("sns.webparts.jobapply.documents"), component: <Uploads/>, id: "uploads"}
]

export { applyBusinessTabs }


// WEBPACK FOOTER //
// ./src/Components/ApplyBusinessTabs.js